// Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

const SOMETHING_WENT_WRONG = "Something went wrong!";

export function getApiErrorMsg(errors: any[]): string {
  for (const error of errors) {
    if (error?.data) {
      const { reason, message } = error.data;
      if (message || reason) {
        return message || reason;
      }
    }
  }
  return SOMETHING_WENT_WRONG;
}

export const imageFromArray = (imageData: number[]) =>
  URL.createObjectURL(
    new Blob([new Uint8Array(imageData)], { type: "image/png" })
  );

export const generateRandomIconColor = (name: string): string => {
  const colors = [
    "#64B5F6", // Blue
    "#FFD54F", // Yellow
    "#7986CB", // Indigo
    "#E57373", // Red
    "#4DB6AC", // Teal
    "#BA68C8", // Purple
    "#AED581", // Light Green
    "#FF8A65", // Deep Orange
    "#90A4AE", // Blue Grey
    "#FFD600", // Amber
    "#E91E63", // Pink
    "#FF6E40", // Deep Orange
    "#FFA726", // Orange
    "#03A9F4", // Light Blue
    "#4A964E", // Green
  ];

  const lowerCaseName = name.toLowerCase();

  let sum = 0;
  for (let i = 0; i < lowerCaseName.length; i++) {
    sum += lowerCaseName.charCodeAt(i);
  }
  return colors[sum % colors.length];
};

